import { render } from "./DrAbhishekDixit.vue?vue&type=template&id=358c9b20"
import script from "./DrAbhishekDixit.vue?vue&type=script&lang=js"
export * from "./DrAbhishekDixit.vue?vue&type=script&lang=js"

import "./DrAbhishekDixit.vue?vue&type=style&index=0&id=358c9b20&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__